import { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom'

import Layout from "../Layout/Layout";
import Header from "../Components/Header";
import Quote from "../Components/Quote";
import Achievement from "../Components/Achievement";
import CardSection from "../Components/CardSection";
import GetQuoteForm from "../Components/GetQuoteForm";
import Team from "../Components/Team";
import { url, header } from "../Constent/Constant";


function AboutUs() {
  const [AboutUsData, setAboutUsData] = useState('')
  const history = useHistory()

  const LoggedIn = localStorage.getItem('MS-Login')
  if (LoggedIn !== 'true') {
    history.push('/')
  }

  useEffect(() => {
    UpdateData()
  }, [])

  const UpdateData = () => {
    fetch(`${url}/page/viewpagedata`, {
      method: 'POST',
      body: JSON.stringify({
        name: "About Us"
      }),
      headers: header
    })
      .then(res => res.json())
      .then(data => {
        console.log('AboutUs Data ==>', data)
        setAboutUsData(data.doc)
      })
  }

  const UpdateText = (DataObject) => {
    console.log(DataObject)
    if (DataObject !== '') {
      fetch(`${url}/page/updatedata`, {
        method: 'POST',
        body: JSON.stringify({
          id: DataObject.id,
          content: DataObject.text
        }),
        headers: header
      })
        .then(res => res.json())
        .then(data => {
          console.log(data)
          if (data.message === 'Success') {
            UpdateData()
          }
        })
    }
  }

  const UpdateImage = (DataObject) => {
    const Imagedata = new FormData();
    Imagedata.append('image', DataObject.image)
    Imagedata.append('id', DataObject.id)

    fetch(`${url}/page/updateimage`, {
      method: 'POST',
      body: Imagedata
    })
      .then(res => res.json())
      .then(data => {
        console.log(data)
        if (data.message === 'Success') {
          UpdateData()
        }
      })
  }

  return (
    <Layout>
      {/* {AboutUsData !== '' &&
        <Header
          UpdateText={UpdateText}
          UpdateImage={UpdateImage}
          GetData={{
            imgId: AboutUsData.section1image1._id,
            headingId: AboutUsData.section1heading1._id
          }}
          Image={AboutUsData.section1image1.image}
        />} */}

      {AboutUsData !== '' &&
        <Quote
          UpdateText={UpdateText}
          UpdateImage={UpdateImage}
          SubHeading={AboutUsData.section2subheading1.content}
          SectionData={{
            SubHeadingId: AboutUsData.section2subheading1._id,
            image: AboutUsData.section2image1.image,
            imageId: AboutUsData.section2image1._id,
            heading: AboutUsData.section2heading1.content,
            headingId: AboutUsData.section2heading1._id,
            para1: AboutUsData.section2paragraph1.content,
            para1Id: AboutUsData.section2paragraph1._id,
          }} />}

      {AboutUsData !== '' &&
        <CardSection
          UpdateText={UpdateText}
          UpdateImage={UpdateImage}
          Heading={AboutUsData.section3heading1.content}
          HeadingId={AboutUsData.section3heading1._id}
          CardData={{
            card1: {
              img: AboutUsData.section3image1.image,
              imgId: AboutUsData.section3image1._id,
              heading: AboutUsData.section3heading2.content,
              headingId: AboutUsData.section3heading2._id,
              para: AboutUsData.section3paragraph1.content,
              paraId: AboutUsData.section3paragraph1._id,
            },
            card2: {
              img: AboutUsData.section3image2.image,
              imgId: AboutUsData.section3image2._id,
              heading: AboutUsData.section3heading3.content,
              headingId: AboutUsData.section3heading3._id,
              para: AboutUsData.section3paragraph2.content,
              paraId: AboutUsData.section3paragraph2._id,
            },
            card3: {
              img: AboutUsData.section3image3.image,
              imgId: AboutUsData.section3image3._id,
              heading: AboutUsData.section3heading4.content,
              headingId: AboutUsData.section3heading4._id,
              para: AboutUsData.section3paragraph3.content,
              paraId: AboutUsData.section3paragraph3._id,
            }
          }} />}

      {AboutUsData !== '' &&
        <Achievement
          UpdateText={UpdateText}
          UpdateImage={UpdateImage}
          CardSection={{
            image: AboutUsData.section4image1.image,
            imageId: AboutUsData.section4image1._id,
            heading: AboutUsData.section4heading1.content,
            headingId: AboutUsData.section4heading1._id,
            para: AboutUsData.section4paragraph1.content,
            paraId: AboutUsData.section4paragraph1._id,
          }} />}

      {AboutUsData !== '' &&
        <Team
          UpdateText={UpdateText}
          UpdateImage={UpdateImage}
          Heading={AboutUsData.section5heading1.content}
          HeadingId={AboutUsData.section5heading1._id}
          CardData={{
            card1: {
              img: AboutUsData.section5image1.image,
              imgId: AboutUsData.section5image1._id,
              heading: AboutUsData.section5heading2.content,
              headingId: AboutUsData.section5heading2._id,
              para: AboutUsData.section5paragraph1.content,
              paraId: AboutUsData.section5paragraph1._id,
            },
            card2: {
              img: AboutUsData.section5image2.image,
              imgId: AboutUsData.section5image2._id,
              heading: AboutUsData.section5heading3.content,
              headingId: AboutUsData.section5heading3._id,
              para: AboutUsData.section5paragraph2.content,
              paraId: AboutUsData.section5paragraph2._id,
            },
            card3: {
              img: AboutUsData.section5image3.image,
              imgId: AboutUsData.section5image3._id,
              heading: AboutUsData.section5heading4.content,
              headingId: AboutUsData.section5heading4._id,
              para: AboutUsData.section5paragraph3.content,
              paraId: AboutUsData.section5paragraph3._id,
            }
          }} />}
      {
        AboutUsData && <GetQuoteForm UpdateImage={UpdateImage}
          imageID={AboutUsData.image._id} image={AboutUsData.image.image} />
      }
    </Layout>
  );
}

export default AboutUs;
